import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { cn } from '@/lib/utils';

export type DrawerSize = 'small' | 'medium' | 'large' | 'full';

const sizeClasses: Record<DrawerSize, string> = {
  small: 'w-[400px]',
  medium: 'w-[600px]',
  large: 'w-[800px]',
  full: 'w-screen',
};

export interface IFramePanelProps {
  isOpen: boolean;
  onDismiss: () => void;
  title: string;
  url: string;
  type?: DrawerSize;
  isBlocking: boolean;
  focusTrapZoneProps: any;
}

const IFramePanel: React.FC<IFramePanelProps> = ({
  isOpen,
  onDismiss,
  title,
  url,
  type = 'medium',
  isBlocking,
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onDismiss()}>
      <SheetContent
        side="right"
        className={cn(sizeClasses[type], 'p-0 flex flex-col')}
        onInteractOutside={(e) => { if (isBlocking) e.preventDefault(); }}
      >
        <SheetHeader className="p-4 border-b border-border">
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        <iframe src={url} title={title} className="w-full flex-1 border-0" />
      </SheetContent>
    </Sheet>
  );
};

export default IFramePanel;
